module.exports = __webpack_public_path__ + "static/grim-cb38d4557843040f684144d17955fce8.gif";